export default (props, vars) => () =>
  props?.['onViewProgress'] && props?.['onViewProgress'](props?.['id']);
